import { h } from "preact";
import AlertCollapse from '../../../_common/components/AlertCollapse/AlertCollapse'
import { ButtonPrimary } from '../../../_common/components/buttons/buttons'
import { Fragment } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import {downloadFileFtp, fetchAllDocuments} from "../../../_rx/fct/actions";
import {useEffect, useState} from "preact/hooks";
import { useParams } from 'react-router'
import { t } from '../../../_i18n'


export default function AlertSurvey ({ className }) {
  const { pathname } = useLocation()
  const { id } = useParams()
  const [data, setData] = useState(null)
  const finalEvaluationTemplate = data?.blocks?.other_docs?.documents?.final_evaluation_template

    useEffect(() => {
        fetchAllDocuments(id).then((data) => setData(data))
    }, [])

  const handleDownloadTemplate = () => {
    if (!finalEvaluationTemplate) return

    downloadFileFtp(
      finalEvaluationTemplate.id,
      finalEvaluationTemplate.file_name
    )
  }

  return (
    <Fragment>
      <AlertCollapse title={t('👋 Nos tienes que enviar las valoraciones finales de las prácticas')} className={className}>
        <li style="margin-bottom: 18px;">
            {t('Descárgate la plantilla de valoraciones finales:')}
            <span
                className='ftp-link font-bold cursor-pointer'
                onClick={handleDownloadTemplate}>
                ‘Valoraciones finales.pdf’
            </span>
        </li>
        <Link
            to={`${pathname}/encuesta`}>
            <ButtonPrimary>
                {t('Subir valoraciones finales')}
            </ButtonPrimary>
        </Link>
      </AlertCollapse>
    </Fragment>
  )
}
